/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.tickets.create.definition.controllers', [
  'acme.common.service.ticketConfig',
  'acme.common.service.api'
])

.controller('LayoutsTicketsCreateDefinitionController', ['$scope', 'TicketConfigService', 'ApiService', function($scope, TicketConfigService, ApiService) {

    $scope.layoutsTicketsCreateDefinition = {

      model: {},
      printers: [],
      layoutLevels: TicketConfigService.getLayout('tickets'),
      tenantTicketConfig: {},

      hasEnabledPrinters: false,

      init: function() {
        this.model = TicketConfigService.getModel();
        this.getDefaultTicketConfig();
        $scope.$on('LayoutsTickets::Save', this.onLayoutsTicketsSave);
        $scope.$on('LayoutsTickets::Update', this.onLayoutsTicketsUpdate);
      },

      getDefaultTicketConfig: function() {
        ApiService.themes.getTicketConfig().then(this.success.getDefaultTicketConfig, this.error.getDefaultTicketConfig);
      },

      getPrinters: function() {
        ApiService.tickets.printers.list().then(this.success.getPrinters, this.error.getPrinters);
      },

      process: function(list) {
        var i, ii,
          printerConfig,
          printersList = [];
        list = list || [];
        for (i = 0, ii = list.length; i < ii; i++) {
          if ( list[i].printerId && list[i].enabled) {
            printerConfig = this.getConfigForPrinter(list[i]);
            list[i].config = printerConfig.config || '';
            list[i].selection = printerConfig.selection || this.layoutLevels[0].value;
            printersList.push(list[i]);
          }
        }
        if (printersList.length) {
          this.hasEnabledPrinters = true;
        }
        return printersList;
      },

      getConfigForPrinter: function(printer) {
        var i, ii,
            r = '',
            selection;
        if (this.model.id) {
          if (this.model && this.model.printerConfigs instanceof Array && this.model.printerConfigs.length) {
            for (i = 0, ii = this.model.printerConfigs.length; i < ii; i++) {
              if( this.model.printerConfigs[i].printerId && (this.model.printerConfigs[i].printerId === printer.printerId) ) {
                selection = this.model.printerConfigs[i].selection || this.layoutLevels[0].value;
                r = {
                  selection: selection,
                  config: (selection === this.layoutLevels[0].value) ? '' : this.model.printerConfigs[i].config
                };
                break;
              }
            }
          }
        }

        return r;
      },

      getDefaultConfigForPrinter: function(printer) {
        var r = '',
            printerName;
        if (this.tenantTicketConfig && printer && printer.name) {
          for (printerName in this.tenantTicketConfig) {
            if (this.tenantTicketConfig.hasOwnProperty(printerName) && printerName === printer.name) {
              r = this.tenantTicketConfig[printerName] || '';
              break;
            }
          }
        }

        return r;
      },

      isLayoutSelection: function(printer, type) {
        return printer && printer.selection && type && (printer.selection === type);
      },

      save: function() {
        var processed = this.marshall();
        if (processed) {
          TicketConfigService.setModel(angular.extend(this.model, processed));
        }
      },

      marshall: function() {
        var i, ii,
          model = {},
          data = [],
          config,
          name,
          canProcess;
        for (i = 0, ii = this.printers.length; i < ii; i++) {
          // Send empty string to backend if it's not custom
          config = '';
          name = this.printers[i].name;
          if (this.isLayoutSelection(this.printers[i], 'custom') && this.printers[i].config) {
            config = this.printers[i].config;
          }
          data.push(
            {
              printerId: this.printers[i].printerId,
              name: name,
              config: config,
              selection: this.printers[i].selection || this.layoutLevels[0].value
            }
          );
        }

        canProcess = data.length;

        if (canProcess) {
          if (this.model.id) {
            model.id = this.model.id;
          }
          model.printerConfigs = data;
        }

        return canProcess ? (model) : canProcess;
      },

      success: {
        init: function(response) {},
        getDefaultTicketConfig: function(response) {
          var self = $scope.layoutsTicketsCreateDefinition;
          self.tenantTicketConfig = response.data.payload.ticketConfig;
          self.getPrinters();
        },
        getPrinters: function(response) {
          var self = $scope.layoutsTicketsCreateDefinition;
          self.printers = self.process(response.data.payload);
        }
      },

      error: {
        init: function(response) {},
        getDefaultTicketConfig: function(response) {
          $scope.layoutsTicketsCreateDefinition.getPrinters();
        },
        getPrinters: function(response) {}
      },

      onLayoutsTicketsSave: function(e, data) {
        var self = $scope.layoutsTicketsCreateDefinition;
        self.save();
      },

      onLayoutsTicketsUpdate: function(e, data) {
        var self = $scope.layoutsTicketsCreateDefinition;
        self.model = TicketConfigService.getModel();
      }

    };

    $scope.layoutsTicketsCreateDefinition.init();

}]);